import {
  AppDispatch,
  AppState,
  fullstorySelectors,
  getAllSpacesReady,
  savedSpacesList,
  SpaceRequestActions,
} from '@fullstory/redux';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useSpaces = (enabled: boolean = true) => {
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const spaces = useSelector(savedSpacesList);
  const isReady = useSelector(getAllSpacesReady);
  const error = useSelector((state: AppState) => state.spaces.allSpaces.error);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (enabled) {
      dispatch(SpaceRequestActions.getAllSpaces({ orgId, query: '', includeAccessInfo: false }));
    }
  }, [dispatch, enabled, orgId]);

  return { spaces, error, isReady };
};
